import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSubtitlesStyle0 = cosmosIconCss;

const CosmosIconSubtitles$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSubtitles extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5022384752157ec1bf627ffbfe9f59229fddca58', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2178587cb145af7553364134c8e477441510a5a7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9b39a8d83c536616a62df39a4c748ebb8f79e8bf', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 3H20v11.5a.5.5 0 0 1-.5.5H13l-5.51 4.59a.3.3 0 0 1-.49-.23V15H2.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5Zm16 10.5v-9h-15v9H8a.5.5 0 0 1 .5.5v2.8l3.82-3.18a.47.47 0 0 1 .32-.12h5.86Z", fill: "currentColor" }), h("path", { key: '6cc289586457efa5505ce57a8d849e37cb8939e5', d: "M6 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-6A.5.5 0 0 1 6 8v-.5Zm5 3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.5Zm3-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-1A.5.5 0 0 1 14 8v-.5Zm-8 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 6 11v-.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSubtitlesStyle0; }
}, [1, "cosmos-icon-subtitles", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-subtitles"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-subtitles":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSubtitles$1);
            }
            break;
    } });
}

const CosmosIconSubtitles = CosmosIconSubtitles$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSubtitles, defineCustomElement };
